(function() {
  var currentHost = window.location.hostname.toLowerCase();
  var isEnglishDomain = currentHost.indexOf('blitzdeco.com') !== -1;

  if (!isEnglishDomain) return;

  var observer = new MutationObserver(function(mutations) {
    var container = document.querySelector('.bss-b2b-registration-form-after-hide');
    if (container) {
      container.innerHTML = 
        '<h2 style="text-align: center;">Thank you for registering!</h2>' +
        '<p style="text-align: center;">Your B2B account application has been received and is currently being reviewed by our team. You have just received a confirmation email, and a follow-up email will be sent once your account has been approved.</p>';
      observer.disconnect(); 
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
